import { render, staticRenderFns } from "./EventTypeModal.vue?vue&type=template&id=1d2eb778&scoped=true"
import script from "./EventTypeModal.vue?vue&type=script&lang=js"
export * from "./EventTypeModal.vue?vue&type=script&lang=js"
import style0 from "./EventTypeModal.vue?vue&type=style&index=0&id=1d2eb778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2eb778",
  null
  
)

export default component.exports